class MegaVariants extends HTMLElement {
  connectedCallback() {
    // console.log('MegaVariants connected, in connectedCallback')

    var config = JSON.parse(document.getElementById('megaProductConfigJson').textContent)
    var rawVariants = JSON.parse(document.getElementById('megaVariantsJson').textContent)

    this.numTimesTriedToInit = 0

    // console.log('\n **** rawVariants xx', rawVariants)
    this.megaProductConfig = config
    this.megaVariants = this._parseMegaVariants(rawVariants, config)
    this.mastorSelectList = document.querySelector('select[data-mega-selector]')
    this.productId = this.mastorSelectList.dataset.productId

    // console.log('this.productId = ', this.productId)
    // console.log('this.mastorSelectList = ', this.mastorSelectList)

    // console.log('\n **** megaVariants xx', config)

    if (!this.megaVariants || !this.megaProductConfig || !this.megaProductConfig.options) {
      console.log('returning without setting up mega product, megaVariants is null')
      return
    }
    //check for variant in query string
    var urlParams = new URLSearchParams(window.location.search)
    var variantId = urlParams.get('variant')

    var initialVariant = variantId
      ? this.megaVariants.find((variant) => variant.id == variantId)
      : this.megaVariants.find((variant) => variant.available)
    if (!initialVariant) initialVariant = this.megaVariants[0]

    // console.log('initialVariant = ', initialVariant)

    //prob not needed...this is for the basic select list
    this.masterForm = document.getElementById(this.getAttribute('form-id'))
    this.masterSelector = document.getElementById('selectedVariantId')
    // console.log('this.masterForm = ', this.masterForm)
    // console.log('this.masterSelector = ', this.masterSelector)

    if (!this.masterSelector) {
      console.warn(
        `The variant selector for product with handle ${this.productHandle} is not linked to any product form.`
      )
      return
    }

    this.masterSelector.value = initialVariant.id

    this.optionSelectors = Array.from(this.querySelectorAll('[data-selector-type]'))
    this.product = { variants: this.megaVariants, options: config.options }

    // console.log('this.masterSelector.value = ', this.masterSelector.value)

    // const container = document.getElementById('productForm'); // Replace with your parent element

    // Add a single event listener to the container

    this.masterForm.addEventListener(
      'change',
      function (event) {
        if (event.target.matches('[name^="option"]')) {
          // console.log('masterSelector change event', event.target.value)
          this._onOptionChanged(event) // Call your handler
        }
      }.bind(this)
    )

    this.initSelectedOptions(initialVariant, config)
    this.selectVariant(initialVariant.id, 0)
    this._updateDisableSelectors(0)
  }

  get selectedVariant() {
    return this._getVariantById(parseInt(this.masterSelector.value))
  }

  get hideSoldOutVariants() {
    return false
  }

  selectVariant(id, optionChangedIndex) {
    var _a

    if (id == -1) {
      // console.log('SEARCHING FOR FIRST AVAILABLE VARIANT, id = -1')
      // this._log("in selectVariant calling _getFirstMatchingAvailableOrSelectableVariant")
      id = this._getFirstMatchingAvailableOrSelectableVariant()['id']
      // console.log('found first matching variant, id = ', id)
      // this._log("in selectVariant calling RETURN, using id =" ,id)
    }

    //maybe need to uncomment?
    // if (((_a = this.selectedVariant) == null ? void 0 : _a.id) === id) {
    //   // console.log('selectVariant returning doing nothing')
    //   return
    // }

    this.masterSelector.value = id

    console.log('selected variant is now ', this.selectedVariant)
    //need to set radio buttons to current variant
    var radioOptions = this.querySelectorAll('[name^="option"]')
    radioOptions.forEach((optionItem) => {
      if (this.selectedVariant.options[optionItem.dataset.optionNormalized] === optionItem.value) {
        optionItem.checked = true
      }
    })

    // this.masterSelector.dispatchEvent(new Event('change', { bubbles: true }))

    const newUrl = new URL(window.location.href)
    if (id) {
      newUrl.searchParams.set('variant', id)
    } else {
      newUrl.searchParams.delete('variant')
    }
    window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString())

    this._updateDisableSelectors(optionChangedIndex)

    //update the label for each radio group section
    this.applyLabelsForCurrentOptions()
    this.selectImageInCarousel(this.selectedVariant)

    // triggerEvent(this.masterSelector.form, 'variant:changed', {
    //   variant: this.selectedVariant,
    // })

    this.mastorSelectList.value = id

    if (window.selectCallbackMegaProduct) {
      // console.log('calling selectCallbackMegaProduct')
      window.selectCallbackMegaProduct(this.selectedVariant, this.productId)
      this.numTimesTriedToInit = -1
    } else {
      setTimeout(() => {
        // console.log('Setting timeout for calling selectCallbackMegaProduct')
        if (this.numTimesTriedToInit != -1 && this.numTimesTriedToInit < 15) {
          this.numTimesTriedToInit += 1
          return this.selectVariant(id, 0)
        }
      }, 200)
    }
  }

  _onOptionChanged(event) {
    var target = event.target
    var optionChangedIndex = parseInt(target.dataset.optionNormalized, 10)
    // this._log("_onOptionChanged event = ", event)
    var _a = this._getVariantFromOptions()
    // console.log('_a = ', _a)
    //this._log(" new variant options is _a ",_a )
    var id = _a ? _a.id : -1 //if -1, then this variant options is not selectable, need to find the first selectable variant and narrow from there
    this.selectVariant(id, optionChangedIndex)
  }

  _getVariantById(id) {
    return this.product['variants'].find((variant) => variant['id'] === id)
  }

  _getVariantFromOptions() {
    const options = this._getSelectedOptionValues()
    // console.log('in _getVariantFromOptions, options = ', options)
    return this.product['variants'].find((variant) => {
      return variant['options'].every((value, index) => value === options[index])
    })
  }

  _isVariantSelectable(variant) {
    if (!variant) {
      return false
    } else {
      return variant['available'] || (!this.hideSoldOutVariants && !variant['available'])
    }
  }
  _getFirstMatchingAvailableOrSelectableVariant() {
    let options = this._getSelectedOptionValues(),
      matchedVariant = null,
      slicedCount = 0
    do {
      options.pop()
      slicedCount += 1
      matchedVariant = this.product['variants'].find((variant) => {
        if (this.hideSoldOutVariants) {
          return (
            variant['available'] &&
            variant['options']
              .slice(0, variant['options'].length - slicedCount)
              .every((value, index) => value === options[index])
          )
        } else {
          return variant['options']
            .slice(0, variant['options'].length - slicedCount)
            .every((value, index) => value === options[index])
        }
      })
    } while (!matchedVariant && options.length > 0)

    return matchedVariant
  }

  _getSelectedOptionValues() {
    const options = []
    Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]')).forEach((option) =>
      options.push(option.value)
    )
    // console.log('_getSelectedOptionValues = ', options)
    return options
  }

  selectImageInCarousel(variant) {
    if (!this.selectedVariant.featured_media || !this.selectedVariant.featured_media.id) {
      return
    }

    try {
      const mediaId = this.selectedVariant.featured_media.id
      // Select the list item using the data attribute
      // console.log(`using selector: div.gallery-cell[data-image-id="${mediaId}"]`)
      const galleryCell = document.querySelector(`div.gallery-cell[data-image-id="${mediaId}"]`)

      if (!galleryCell) {
        console.log('List item not found.')
        return -1 // Return -1 if the item doesn't exist
      }

      // Get all list items inside the parent <ul>
      const galleryCellItems = Array.from(galleryCell.parentElement.children)

      // Find the index of the selected list item
      const imagePosition = galleryCellItems.indexOf(galleryCell)

      // console.log(`Index position: ${imagePosition}`)

      // Select the carousel element
      var flkty = Flickity.data('.js-product-gallery')
      flkty.select(imagePosition)
    } catch (err) {
      console.log('Error in selectImageInCarousel', err)
    }
  }

  applyLabelsForCurrentOptions() {
    for (var i = 0; i < this.optionSelectors.length; i++) {
      var _node = this.optionSelectors[i]
      if (!_node) return
      var _span = _node.querySelector('span.product-form__option-value')
      if (_span) _span.innerHTML = this.selectedVariant.options[i]
    }
  }

  initSelectedOptions(initialVariant, config) {
    //INIT MEGA PRODUCT OPTIONS

    var radioOptions = this.querySelectorAll('[name^="option"]')
    radioOptions.forEach((optionItem) => {
      if (initialVariant.options[optionItem.dataset.optionNormalized] === optionItem.value) {
        optionItem.checked = true
      }
    })

    //initialize the label for each radio group section
    this.applyLabelsForCurrentOptions()

    for (let optionsIndex = 0; optionsIndex < this.product.options.length; optionsIndex++) {
      var currentOptionsSet = this.product.options[optionsIndex]

      currentOptionsSet.values.forEach((optionValue, optionValueIndex) => {
        //value is `Mid Stem` or `C` or `9`, etc
        var blnDisplayOptionValue = this.product.variants.some((variant) => {
          return optionValue == variant.options[optionsIndex]
        })
        if (blnDisplayOptionValue) {
          //  this._log(`INDX ${optionsIndex}: INIT - found TRUE for ${optionValue}`)
          this._applyClassToSelector(this.optionSelectors[optionsIndex], optionValueIndex, true, true)
        } else {
          // this._log(`INDX ${optionsIndex}: INIT - found FALSE for ${optionValue}`)
          this._applyClassToSelector(this.optionSelectors[optionsIndex], optionValueIndex, false, false)
        }
      })
    }
  }

  _applyClassToSelector(selector, valueIndex, available, hasAtLeastOneCombination) {
    // console.log('in applyClassToSelector', selector, valueIndex, available, hasAtLeastOneCombination)

    // console.log('_applyClassToSelector selector = ', selector)

    var cssSelector = `.la-block-swatch:nth-child(${valueIndex + 1})`

    // console.log('_applyClassToSelector cssSelector = ', cssSelector)
    // console.log('selector.querySelector(cssSelector) = ', selector.querySelector(cssSelector))

    selector.querySelector(cssSelector).toggleAttribute('hidden', !hasAtLeastOneCombination)
    selector.querySelector(cssSelector).classList.toggle('is-disabled', !available)
  }

  /**
   *
   * @param {string} optionChangedIndex
   * @returns
   */
  _updateDisableSelectors(optionChangedIndex) {
    var selectedVariant = this.selectedVariant
    var optionChangedIndexPlusOne = optionChangedIndex + 1

    if (!selectedVariant) {
      console.log('In _updateDisableSelectors with no selectedVariant XXXXX - How did we get here?')
      return
    }

    var optionsBaseline = selectedVariant.options.slice(0, optionChangedIndexPlusOne) //this will be our 'fixed' baseline we filter other variants from
    var optionsBaselineSerialized = JSON.stringify(optionsBaseline)

    //now get all variants that have this baseline
    var baselineVariants = this.product.variants.filter((variant) => {
      return JSON.stringify(variant.options.slice(0, optionChangedIndexPlusOne)) === optionsBaselineSerialized
    })

    // console.log('baselineVariants = ', baselineVariants)

    var blnHideOption3 =
      baselineVariants.filter(
        (variant) =>
          variant.options.slice(0, 2).toString() === selectedVariant.options.slice(0, 2).toString() &&
          variant.option3 !== 'Default'
      ).length === 0

    var blnHideOption4 =
      baselineVariants.filter(
        (variant) =>
          variant.options.slice(0, 3).toString() === selectedVariant.options.slice(0, 3).toString() &&
          variant.option4 !== 'Default'
      ).length === 0

    this.optionSelectors[3].hidden = blnHideOption3
    this.optionSelectors[4].hidden = blnHideOption4

    for (let optionsIndex = optionChangedIndexPlusOne; optionsIndex < this.product.options.length; optionsIndex++) {
      //first get the unique set of options that exist in Baseline Variants at this option position
      var optionKey = `option${optionsIndex}`
      var selectedOptionsBaseline = selectedVariant.options.slice(0, optionsIndex).toString()

      var narrowedVariants = baselineVariants.filter(
        (variant) => variant.options.slice(0, optionsIndex).toString() == selectedOptionsBaseline
      )

      // console.log('narrowedVariants = ', narrowedVariants)

      var optionValuesToDisplay = [...new Set(narrowedVariants.map((variant) => variant[optionKey]))]

      // console.log('optionValuesToDisplay = ', optionValuesToDisplay)

      this.product.options[optionsIndex].values.forEach((optionValue, optionValueIndex) => {
        var blnDisplayOptionValue = optionValuesToDisplay.includes(optionValue)

        if (blnDisplayOptionValue) {
          //note for this we aren't looking at any truth of the option being in stock, just that it EXISTS in our list of mega variants
          var blnAvailable = true

          if (optionsIndex >= 2) {
            blnAvailable = narrowedVariants.some((variant) => {
              return variant.available == true && variant.options[optionsIndex] === optionValue
            })
          }

          this._applyClassToSelector(this.optionSelectors[optionsIndex], optionValueIndex, blnAvailable, true)
        } else {
          this._applyClassToSelector(this.optionSelectors[optionsIndex], optionValueIndex, false, false)
        }
      })
    }
  }

  _parseMegaVariants(rawVariants, config) {
    /*
     *   Black Prefans
     *       1 - Dimension
     *       2 - Curl
     *       3 - Diameter
     *       4 - Length
     */
    try {
      var parsedMegaVariants = rawVariants
        .map((variant) => {
          if (!variant.sku) {
            console.error('NO SKU for variant, returning null ', variant)
            return null
          }

          var _sku = variant.sku.toUpperCase()
          variant.option3 = variant.option3 || 'Default' //in some cases, option3 is null for some products
          variant.option4 = 'Default'

          //no matter the type, always split out the piped option 4
          if (variant.option3 && variant.option3.indexOf('|') > 0) {
            // blnFourthOptionExists = true;
            variant.title = variant.title.replace('|', ' / ')
            var newOptions = variant.option3.split('|')

            variant.option3 = newOptions[0]
            variant.option4 = newOptions[1]
          }

          var oldOptions = {
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
            option4: variant.option4,
          }

          if (config.id === 'premade-single-length-mega') {
            /*
              Black Prefans
              0 - Dimension - derived from the product title
              1 - Curl
              2 - Length
              3 - Diameter
              4 - NOT USED

              For the Mixed trays:
              - Gill needs to shift the variants to use pipe on option 3 for the diameter
            */

            // console.log(' in config for premade-single-length-mega')

            variant.option0 = this._getFanTypeByTitle(variant.name)
            variant.option1 = oldOptions.option1
            variant.option2 = oldOptions.option2
            variant.option3 = oldOptions.option3.replace('mm', '')
            variant.option4 = oldOptions.option4
          } else if (config.id === 'super-sale-trays-mega') {
            variant.option0 = oldOptions.option1
            variant.option1 = oldOptions.option2
            variant.option2 = oldOptions.option3.replace('mm', '')
            variant.option3 = 'Default'
            variant.option4 = 'Default'
          } else if (config.id === 'volume-lashes-mega') {
            var splitNameFirstItem = variant.name.split(' ')[0]

            var diameter = 'X'

            if (variant.name.includes('0.03')) {
              diameter = '0.03'
            } else if (variant.name.includes('0.05')) {
              diameter = '0.05'
            } else if (variant.name.includes('0.06')) {
              diameter = '0.06'
            } else if (variant.name.includes('0.07')) {
              diameter = '0.07'
            }

            if (splitNameFirstItem === 'Matte') {
              variant.option0 = 'Matte'
              variant.option1 = oldOptions.option1
              variant.option2 = diameter
              variant.option3 = oldOptions.option2.replace('mm', '')
              variant.option4 = 'Default'
            } else if (splitNameFirstItem === 'Satin') {
              variant.option0 = 'Satin'
              variant.option1 = oldOptions.option1
              variant.option2 = diameter
              variant.option3 = oldOptions.option2.replace('mm', '')
              variant.option4 = 'Default'
            } else if (splitNameFirstItem === 'Brown') {
              //option1 has Med Brown or Dark Brown
              variant.option0 = oldOptions.option1
              variant.option1 = oldOptions.option2
              variant.option2 = diameter
              variant.option3 = oldOptions.option3.replace('mm', '')
              variant.option4 = 'Default'
            }
          } else if (config.id === 'classic-lashes-mega') {
            var splitNameFirstItem = variant.name.split(' ')[0]

            var diameter = 'X'

            if (variant.name.includes('0.10')) {
              diameter = '0.10'
            } else if (variant.name.includes('0.12')) {
              diameter = '0.12'
            } else if (variant.name.includes('0.15')) {
              diameter = '0.15'
            } else if (variant.name.includes('0.18')) {
              diameter = '0.18'
            }

            if (splitNameFirstItem === 'Satin') {
              variant.option0 = 'Satin'
              variant.option1 = oldOptions.option1
              variant.option2 = diameter
              variant.option3 = oldOptions.option2.replace('mm', '')
              variant.option4 = 'Default'
            } else if (splitNameFirstItem === 'Brown') {
              //option1 has Med Brown or Dark Brown
              variant.option0 = oldOptions.option1
              variant.option1 = oldOptions.option2
              variant.option2 = diameter
              variant.option3 = oldOptions.option3.replace('mm', '')
              variant.option4 = 'Default'
            }
          } else {
            console.error('returning null for variant. No option mapping logic defined ', variant)
            return null
          }

          //finished processing per type
          //Set the options array to the new vaules and then return the variant
          variant.options = [variant.option0, variant.option1, variant.option2, variant.option3, variant.option4]
          return variant
        })
        .filter((item) => item) //safety filter to remove any nulls

      // console.log('parsedMegaVariants=', parsedMegaVariants)
      return parsedMegaVariants
    } catch (err) {
      console.log(err)
    }
  }

  /**
   *
   * @param {string} title
   * @returns Fan dimension. Ex '8D Premade Single Length Fans' returns '8D'
   * @remarks title MUST have the dimension in first part of title
   */
  _getFanTypeByTitle(title) {
    return title.split(' ')[0]
  }
}
customElements.define('mega-variants', MegaVariants)
